/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import greenCircle from "@/src/assets/img/generic/circle_green_100px.png";
import redCircle from "@/src/assets/img/generic/circle_red_100px.png";

const trafficCostRiskSectionStyle = {
  noWinNoFeeSection: {
    textAlign: "center",
  },
  paragraph: {
    marginTop: 0,
  },
  paragraphTop: {
    margin: "auto",
    maxWidth: "700px",
  },
  box: {
    margin: "auto",
    maxWidth: 700,
    borderRadius: "7px",
    border: "1px solid lightgrey",
    height: "100%",
    padding: "0 2rem 1rem 2rem",
  },
  subHeadlineFirst: {
    fontWeight: 500,
    paddingTop: "2rem",
  },
  subHeadlineSecond: {
    fontWeight: 500,
    paddingTop: "2rem",
    paddingBottom: "1rem",
  },
  subHeadlineThird: {
    fontWeight: 500,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url(${greenCircle})`,
    maxWidth: 250,
    margin: "0 auto",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  },
  subHeadlineForth: {
    fontWeight: 500,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url(${redCircle})`,
    maxWidth: 250,
    margin: "0 auto",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  },
  costsSecureIcon: {
    marginTop: "2rem",
    width: "150px",
    height: "auto",
  },
};

export default trafficCostRiskSectionStyle;
